/**
 * Route for `abnormal-pattern-ml`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AbnormalPatternMlPage } from "../features/abnormal-pattern-ml/AbnormalPatternMlPage";

export const abnormalPatternMlRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/abnormal-pattern-ml",
	component: AbnormalPatternMlPage,
});

export default abnormalPatternMlRoute;
